import React from "react";
import {
  Image,
  Button,
  Space,
  Row,
  Col,
  message,
  Modal,
  Tooltip,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import NotificationStore from "../store/NotificationStore";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";
import NotificationAdd from "./NotificationAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
class NotificationList extends React.Component {
  constructor(props, context) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.notificationStore = new NotificationStore();
    this.companyStore = new CompanyStore();
    this.onDelete = this.onDelete.bind(this);
    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      companyVal_Lab: "",
      notificationId: "",
      listDataUpdate: false,
      openNotificationAddForm: false,
      companyId: "",
      openDeleteModal: false,
      deleteData: {},
      editData: {},
    };
    this.columns = [
      {
        // title: "Date Time ",
        title: context.translate("_DATE_TIME_"),
        dataIndex: "postedAt",
        width: 35,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("notificationlist") &&
                    this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        // title: "Notification",
        title: context.translate("_NOTIFICATION_"),
        dataIndex: "notification",
        width: 30,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Status",
        title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
        dataIndex: "sendNow",
        width: 30,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value === 0) {
            return "Pending";
          } else if (value === 1) {
            return "Sent";
          }
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        align: "center",
        ellipsis: {
          showTitle: true,
        },
        width: 5,
        render: (_, record) => {
          return (
            <>
              <Space>
                {this.props.canUpdate("notificationlist") && (
                  <Tooltip
                    title={this.context.translate("_EDIT_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: "19px",
                        width: "14px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>
                )}
                {this.props.canDelete("notificationlist") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "14px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
                {/* <Link
                  onClick={(e) => {
                    e.preventDefault();
                    this.onEdit(record);
                  }}
                >
                  <Tooltip
                    // title="Edit Notification"
                    title={this.context.translate("_EDIT_NOTIFICATION_")}
                    placement="bottom"
                    color={config.tooltipColorEdit}
                  >
                    <EditFilled />
                  </Tooltip>
                </Link> */}
                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Link>
                    <Tooltip
                      //  title="Delete Notification"
                      title={context.translate("_DELETE_NOTIFICATION_")}
                      placement="bottom"
                      color={config.tooltipColorDelete}
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm> */}
              </Space>
            </>
          );
        },
      },
    ];
  }

  async componentDidMount() {
    // const data=JSON.parse(base64_decode(this.cookies.get("data")))
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }

    this.setState({ pageSize: 50 });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      Number(this.props.getUserData().isadmin) === 1 ||
      Number(this.props.getUserData().isadmin) === 0
    ) {
      this.props.navigate("/login");
    }

    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setNotificationStates =
        this.context.viewStateStore.notificationListObject;

      if (setNotificationStates.companyId !== "") {
        await this.notificationStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,

          companyId: setNotificationStates.companyId,
        });

        const singleData = await this.companyStore.getCompanyDataById(
          setNotificationStates.companyId
        );

        await this.setState({ loadList: 1 });

        await this.setState({
          companyVal_Lab: singleData,
          companyId: setNotificationStates.companyId,
        });

        await this.setState({ listDataUpdate: false });
      }
    }
  }
  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.notificationStore.loadData({
      companyId: this.state.companyId,
      offset: this.state.currentPage - 1,
      limit: this.state.pageSize,
    });
    await this.setState({ loadList: 1 });
  }

  handleChange = async (comp) => {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);

    await this.setState({ companyVal_Lab: singleData, companyId: comp.value });

    await this.handleSearch();
  };

  onEdit = async (record) => {
    const notificationId = record.notification_Id;

    if (notificationId) {
      this.context.viewStateStore.setNotificationStates({
        companyId: record.companyId,
      });

      await this.setState({ notificationId: notificationId });
      await this.setState({ openNotificationAddForm: true });
    }
  };

  async onDelete(record) {
    const response = await this.notificationStore.deleteRecord({
      notification_Id: record.notification_Id,
      companyId: this.state.companyId,
    });
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  responseMsg = async (resp) => {
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openNotificationAddForm: false });

      //  await this.handleSearch();
      // this.props.navigate("/notificationlist");
    }
    // else {
    //   message.error(resp.message);
    // }
    else if (resp?.data?.success === "F0") {
      resp.data.errors.map((value) => {
        message.error(value["inventoryNo"]);
      });
    }
  };

  closeModal = () => {
    this.setState({
      openNotificationAddForm: false,
      notificationId: "",
    });
  };
  refreshList = async () => {
    if (this.state.companyId) {
      this.setState({ loading: true });
      await this.notificationStore.loadData({
        offset: 0,
        limit: 50,
        companyId: this.state.companyId,
      });
      this.setState({ loading: false, currentPage: 1 });
    }
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={this.handleChange}
                  // allowClear={true}
                  style={{ width: 200 }}
                  value={
                    this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                  }
                />
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    marginInlineEnd: "20px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>

              {this.props.canCreate("notificationlist") && (
                <Button
                  className="addButtonClass"
                  onClick={() =>
                    this.setState({
                      openNotificationAddForm: true,
                      notificationId: "",
                    })
                  }
                >
                  <Image
                    style={{ width: 13, marginInlineEnd: "5px" }} //marginInlineEnd: "5px",
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                </Button>
              )}
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.notificationStore?.total}
            columns={this.columns}
            dataSource={this.notificationStore?.notification}
            loading={this.notificationStore?.loading}
            onChange={this.handleTableChange}
          />

          {this.state.openNotificationAddForm && (
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.openNotificationAddForm}
              placement={this.context.locale.language === "english" ? "right" : "left"}
              footer={false}
              title={
                <div className="formTitle">
                  {this.context.translate("_ADD_NOTIFICATION_")}
                  <p className="formDescription">
                    {this.context.translate("_NOTIFICATION_ADD_DESC_")}
                  </p>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ openNotificationAddForm: false })}
              onCancel={() =>
                this.setState({ openNotificationAddForm: false, userId: "" })
              }
            >
              <div style={{ height: "100%" }}>
                <NotificationAdd
                  notificationId={this.state.notificationId}
                  response={this.responseMsg}
                  closeModal={this.closeModal}
                />
              </div>
            </Drawer>
          )}
        </div>
        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
NotificationList.contextType = StoreContext;
export default observer(withRouter(NotificationList));
